import "./IconChevronDown.scss";

interface IconChevronDownProps {
  color?: "white" | "black" | "blue";
}

export const IconChevronDown = ({ color = "white" }: IconChevronDownProps) => {
  return (
    <svg
      className={`IconChevronDown IconChevronDown--${color}`}
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.52344 6.42578L0.273438 1.17578C0 0.929688 0 0.519531 0.273438 0.246094C0.519531 0 0.929688 0 1.20312 0.246094L5.98828 5.05859L10.7734 0.273438C11.0195 0 11.4297 0 11.7031 0.273438C11.9492 0.519531 11.9492 0.929688 11.7031 1.17578L6.42578 6.42578C6.17969 6.69922 5.76953 6.69922 5.52344 6.42578Z"
        fill="white"
      />
    </svg>
  );
};
